import React, { useEffect, useState } from "react";

import {
  CBadge,
  CDropdown,
  CDropdownItem,
  CDropdownMenu,
  CDropdownToggle,
  CTooltip
} from "@coreui/react";
import { RiFireFill } from "react-icons/ri";
import { useSelector } from "react-redux";

import URL from "../../../config/api";
import axios from "../../../config/axios";
import { hasGameficandusModule } from "../../../utils/accessSession";

const WEEKDAY_LABELS = ["Seg", "Ter", "Qua", "Qui", "Sex"];

const StreakBadge = () => {
  const token = useSelector(state => state.user.token);
  const roleType = useSelector(state => state.general.active_roles?.type);
  const userModules = useSelector(state => state.user?.user_modules);
  const hasStreakModule = hasGameficandusModule(userModules);
  const [streak, setStreak] = useState(null);

  useEffect(() => {
    if (roleType !== "A" || !token || !hasStreakModule) {
      setStreak(null);
      return;
    }

    axios
      .get(`${URL.api}streaks/me`, {
        headers: { authorization: `Bearer ${token}` }
      })
      .then(resp => {
        if (resp.status === 200 && resp.data.success) {
          setStreak(resp.data.data);
        }
      })
      .catch(() => {});
  }, [roleType, token, hasStreakModule]);

  if (!streak) {
    return null;
  }

  return (
    <CTooltip content="Ofensiva">
      <CDropdown inNav className="c-header-nav-item mx-2">
        <CDropdownToggle
          className="c-header-nav-link"
          caret={false}
          // Âncora do tour do aluno (components/Tour/roteiros/aluno.js). Ver a
          // nota equivalente em Gamification/XpBadge.
          data-tour="ofensiva"
        >
          <RiFireFill className="header-icon" />
          <CBadge shape="pill" color="warning">
            {streak.current_streak}
          </CBadge>
        </CDropdownToggle>
        <CDropdownMenu
          placement="bottom-end"
          className="pt-0"
          style={{ minWidth: 260 }}
        >
          <CDropdownItem
            header
            tag="div"
            color="light"
            className="border-0 d-flex justify-content-center"
          >
            <strong>Sua ofensiva</strong>
          </CDropdownItem>
          <div className="d-flex justify-content-around px-3 py-2">
            <div className="text-center">
              <div className="font-weight-bold">{streak.current_streak}</div>
              <small className="text-muted">Atual</small>
            </div>
            <div className="text-center">
              <div className="font-weight-bold">{streak.longest_streak}</div>
              <small className="text-muted">Melhor</small>
            </div>
          </div>
          <div className="d-flex justify-content-around px-3 pb-3">
            {streak.week.map(day => (
              <div key={day.date} className="text-center">
                <div
                  className={`rounded-circle d-flex align-items-center justify-content-center mx-auto ${
                    day.done ? "bg-warning text-white" : "bg-light text-muted"
                  }`}
                  style={{ width: 28, height: 28 }}
                >
                  <RiFireFill size={14} />
                </div>
                <small className="text-muted">
                  {WEEKDAY_LABELS[day.weekday - 1]}
                </small>
              </div>
            ))}
          </div>
        </CDropdownMenu>
      </CDropdown>
    </CTooltip>
  );
};

export default StreakBadge;
